import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import { getFullUrl } from 'hubspot-url-utils';
import I18n from 'I18n';
import getLang from 'I18n/utils/getLang';
import PortalIdParser from 'PortalIdParser';
import { ecosystemAppClient, ecosystemPublicClient } from '../../common/clients/ecosystemClient';
import { TYPEAHEAD_SEARCH_RESULTS_LIMIT } from '../../constants/search';
import ThemeSearchBarResult from '../components/ThemeSearchBarResult';
// TODO refactor
export function getThemeMarketplaceUrl(appContext) {
  let urlRoot;

  if (appContext === 'app') {
    urlRoot = `${getFullUrl('app')}/ecosystem/${PortalIdParser.get()}`;
  } else {
    urlRoot = getFullUrl('ecosystem', {
      hubletOverride: 'na1'
    });
    const lang = getLang();

    switch (lang) {
      case 'de':
      case 'es':
      case 'fr':
      case 'ja':
      case 'pt':
        {
          urlRoot += `/${lang}`;
          break;
        }

      default:
        break;
    }
  }

  return `${urlRoot}/marketplace/website`;
}
export function useThemeSearchBarQuery({
  appContext = 'app',
  grouped = false,
  limit = TYPEAHEAD_SEARCH_RESULTS_LIMIT
} = {}) {
  const fetcher = useCallback(input => {
    const client = appContext === 'public' ? ecosystemPublicClient : ecosystemAppClient;
    const response = client.post('themes/search', {
      data: [{
        limit,
        search: input
      }]
    });
    return response.then(([{
      items,
      total
    }]) => {
      const options = items.map(item => {
        const {
          companyName,
          name,
          offeringId,
          slug,
          thumbnailUrl
        } = item;
        return {
          dropdownText: /*#__PURE__*/_jsx(ThemeSearchBarResult, {
            companyName: companyName,
            name: name,
            thumbnailUrl: thumbnailUrl
          }),
          href: `${getThemeMarketplaceUrl(appContext)}/${slug}`,
          item,
          linkUse: 'unstyled',
          text: name,
          value: `theme::${offeringId}`
        };
      });

      if (total > limit) {
        options.push({
          href: `${getThemeMarketplaceUrl(appContext)}/all?eco_search=${input}`,
          text: I18n.text('ecosystemMarketplaceCore.assets.themeSearchBarViewAll', {
            total
          }),
          value: '__VIEW_ALL_THEMES__'
        });
      }

      return options;
    }).then(options => grouped ? [{
      text: I18n.text('ecosystemMarketplaceCore.assets.themeSearchBarGroupLabel'),
      options
    }] : options);
  }, [appContext, grouped, limit]);
  return {
    fetcher
  };
}